import React, { useEffect, useState, forwardRef, useRef } from "react";
import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import EditIcon from '@mui/icons-material/Edit';

import { styled } from '@mui/material/styles';
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
    Box, Button, Grid, Dialog, DialogTitle, TextField, DialogActions, DialogContent,
    TablePagination, Typography, InputAdornment, IconButton, Tooltip, Tab, Card, CardContent, Tabs
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import styles from '../../styles.module.css';
import PropTypes from 'prop-types';
import Breadcrumb from "../reusableComponent/Breadcrumb";
import { Icon } from '@iconify/react';
import { BootstrapDialog, BootstrapDialogTitle } from "../reusableComponent/BootstrapDialog";
import Customer_Supplier_AdvancePaymentAdd from "./Customer_Supplier_AdvancePaymentAdd";
import Customer_Supplier_PaymentAdd from "./Customer_Supplier_PaymentAdd";


const CustomTab = styled(Tab)(({ theme }) => ({
    minWidth: '9px',
    minHeight: '8px',
    // height:'20px',
    marginRight: '2px',
    // border: '1px solid #ffad33',
    // borderRadius: '10px',
    // backgroundColor: '#008080',
    fontWeight: '400',
    fontSize: '13px',
    color: '#000000',
    padding: '4px 4px 4px 4px',
    letterSpacing: '0.3px',
    wordSpacing: '0.8px',
    textTransform: 'none',
    // '&$selected': {
    //     backgroundColor: 'blue',
    // }
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 1 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


function Customer_Supplier_PaymentAddTab(props) {
    let ref = useRef();
    const login_details = sessionStorage.getItem('loginUser');
    const userInfo = JSON.parse(login_details);

    const [value, setValue] = React.useState(props.editInfoAdv ? 1 : 0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const location = useLocation();
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {

        setOpen(false);
    }
    return (
        <>
            {(props.editInfo) ?
                <Button className={`${styles.list_tbl_action_btn}`} onClick={handleClickOpen}>
                    <EditIcon style={{ float: 'left', fontSize: '20px', cursor: 'pointer' }} />
                    <span style={{ marginRight: '13px' }}> Edit Record</span>
                </Button>
                :
                props.editInfoAdv ?
                    <EditIcon style={{  fontSize: '16px', cursor: 'pointer',marginRight: '8px' }} onClick={handleClickOpen} />
                    :
                    props.editInfoDetails ?
                    <EditIcon style={{ float: 'left', fontSize: '20px', cursor: 'pointer' }}  onClick={handleClickOpen} />
                    :
                    <Button variant="contained" onClick={handleClickOpen} className={`${styles.add_btn}`}>
                        <AddIcon viewBox="3 3 18 18" className={`${styles.add_icon}`} /> Create New
                    </Button>
            }
            <BootstrapDialog
                PaperProps={{
                    sx: {
                        maxWidth: "85%",
                        maxHeight: 600,
                        minWidth: "50%",
                        minHeight: 120
                    }
                }}
                onClose={handleClose}
                open={open}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose} >
                    {location.pathname == '/sales' ? 'Create Customer Payment' : 'Create Supplier Payment'}
                </BootstrapDialogTitle>
                <DialogContent dividers >
                    <Paper className='listContainer' sx={{ boxShadow: 'none' }}>
                        <Box sx={{ width: '100%', padding: '4px', paddingTop: '4px' }}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider', maxHeight: '32px', paddingLeft: '12px' }}>
                                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example"
                                    indicatorColor="none"
                                    textColor="#000000"
                                    TabIndicatorProps={{
                                        sx: { backgroundColor: "#ff6600", marginBottom: '17px' }
                                    }}
                                    variant="scrollable">
                                    <CustomTab label={location.pathname == '/sales' ? "Customer Payment" : "Supplier Payment"} {...a11yProps(0)} />
                                    <CustomTab label={location.pathname == '/sales' ? "Customer Advance Payment" : "Supplier Advance Payment"} {...a11yProps(1)} />
                                </Tabs>
                            </Box>
                            <TabPanel value={value} index={0}>
                                <Customer_Supplier_PaymentAdd editInfo={props.editInfo ? props.editInfo : props.editInfoDetails} />
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                <Customer_Supplier_AdvancePaymentAdd editInfoAdv={props.editInfoAdv} />
                            </TabPanel>
                        </Box>
                    </Paper>
                </DialogContent>
            </BootstrapDialog>
        </>
    )
}

export default Customer_Supplier_PaymentAddTab;
